import React from 'react';
import cn from 'classnames';

// DEPRECATED: use src/components/form/Button.component.jsx
const Button = ({ buttonName, className, onClickButton }) => (
  <div data-bem="Button--common" className="flex-child">
    <button
      className={cn({
        'btn btn-violet-link': true,
        className,
      })}
      onClick={onClickButton}
    >
      {buttonName}
    </button>
  </div>
);

export default Button;
